// v3.15-1002: WorkspaceLanding — sends the user to the right home screen
// based on their access scope.  Internal/PTC users historically landed
// on /dashboard; external partners and VO officers land on /clients.
//
// v3.18-1388 CRM-INT-005 — The main Dashboard is now restricted to the
// CEO allow-list.  Only allow-listed users are redirected to /dashboard;
// every other authenticated user (including former Dashboard-eligible
// internal admins) is now sent to /clients so no one accidentally lands
// on the 404 route.
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const WorkspaceLanding = () => {
  const { canViewMainDashboard, user, loading, authChecked } = useAuth();
  if (loading || (!user && !authChecked)) return null;
  return <Navigate to={canViewMainDashboard() ? '/dashboard' : '/clients'} replace />;
};

export default WorkspaceLanding;
